module.exports = __webpack_public_path__ + "static/media/casino-01.32b19feb.jpeg";